export const SOURCES = {
  POLICY_MANAGEMENT: 'policy-management',
}

export const BASE_USERS = [{ label: 'Guests / External Users', value: 'GuestsOrExternalUsers' }]

export const BASE_INCLUDE_USERS = [
  { label: 'All users', value: 'All' },
  { label: 'No users', value: 'None' },
  ...BASE_USERS,
]

export const BASE_LOCATIONS = [{ label: 'All trusted locations', value: 'AllTrusted' }]

export const BASE_INCLUDE_LOCATIONS = [{ label: 'All', value: 'All' }, ...BASE_LOCATIONS]

export const BASE_APPLICATIONS = [
  { label: 'Office 365', value: 'Office365' },
  { label: 'Microsoft Admin Portals', value: 'MicrosoftAdminPortals' },
]

const MICROSOFT_INTUNE_ENROLLMENT_APPLICATION = {
  label: 'Microsoft Intune Enrollment',
  value: '0000000a-0000-0000-c000-000000000000',
}

const AZURE_WINDOWS_VM_SIGN_IN_APPLICATION = {
  label: 'Azure Windows VM Sign-In',
  value: '372140e0-b3b7-4226-8ef9-d57986796201',
}

export const KNOWN_MICROSOFT_APPLICATIONS = [
  MICROSOFT_INTUNE_ENROLLMENT_APPLICATION,
  AZURE_WINDOWS_VM_SIGN_IN_APPLICATION,
]

export const BASE_INCLUDE_APPLICATIONS = [
  { label: 'None', value: 'None' },
  { label: 'All', value: 'All' },
  ...BASE_APPLICATIONS,
]

export const DEFAULT_EMPTY_POLICY = {
  state: 'enabledForReportingButNotEnforced',
  conditions: {
    users: {
      includeUsers: ['None'],
    },
    applications: {
      includeApplications: ['None'],
    },
    clientAppTypes: ['all'],
  },
  grantControls: {
    operator: 'AND',
    builtInControls: ['mfa'],
  },
}

export const POLICY_STATE_REPORT = 'enabledForReportingButNotEnforced'
